import { gql } from "@apollo/client";

export const DEPLOYS_FRAGMENT = gql`
  fragment Deploys on Deploy {
    id
    dedupId
    serviceAlias
    environment
    description
    deployerEmail
    startedAt
    deployedAt
    deployUrl
    deployNumber
    duration
    commitMessage
    commitBranch
    commitSha
    commitAuthorName
    commitAuthorEmail
    commitAuthoringDate
    associatedUser {
      id
      name
      email
      href
      avatar
      deactivatedAt
    }
    status
    deployStatus
    author
    providerName
    providerType
    providerUrl
    service {
      name
      href
      owner {
        href
        name
      }
    }
  }
`;

export const DEPLOYS_QUERY = gql`
  query deploys(
    $service: ID
    $start: ISO8601DateTime!
    $end: ISO8601DateTime!
    $after: String
    $first: Int
    $environments: [String!]
    $providers: [ID!]
    $statuses: [DeployStatusEnum!]
  ) {
    account {
      deploys(
        after: $after
        first: $first
        serviceId: { id: $service }
        environments: $environments
        start: $start
        end: $end
        providers: $providers
        statuses: $statuses
      ) {
        pageInfo {
          startCursor
          hasNextPage
          hasPreviousPage
        }
        hasDeploys
        totalCount
        filteredCount
        nodes {
          ...Deploys
        }
      }
    }
  }
  ${DEPLOYS_FRAGMENT}
`;
